module.exports = __webpack_public_path__ + "img/cs-logo-new-slim.0088c7ff.png";